import Average from './Average';
import Count from './Count';
import Rate from './Rate';
import RecentValue from './RecentValue';
import Sum from './Sum';

export default { Average, Count, Rate, RecentValue, Sum };
